window.envyQuizLanding = new Vue({
    el : '.main',

    settings : {
        domain: window.WBK_Settings.staticServerUrl,
        apiUrl: window.WBK_Settings.serverUrl + '/api/quizes/',
    },

    data : {
        siteId : window.siteId,
        widgetId : window.widgetId,
        quiz: null,
        s: {},
        show: false,
        buttonShowed: false,
        is_envybox: false,
        serviceName: null,
        partnerLink: null,
        loading: true,
        visibility: 'hidden',
        landingStatuses: {
            enabling: {
                notEnabled: {
                    id: 0,
                    title: 'Не активирован',
                },
                enabled: {
                    id: 1,
                    title: 'Активирован',
                },
            },
            viewTypes: {
                button: {
                    id: 0,
                    title: 'Показывать кнопку',
                },
                inline: {
                    id: 1,
                    title: 'Показывать сразу',
                },
            },
            backgroundTypes: {
                color: {
                    id: 0,
                    name: 'Цвет',
                },
                image: {
                    id: 1,
                    name: 'Изображение',
                }
            },
            backgroundImgUploading: {
                notUploaded: {
                    id: 0,
                    title: 'Фон не загружен',
                },
                uploaded: {
                    id: 1,
                    title: 'Фон загружен',
                },
            },
            integrationCode: {
                notEnabled: {
                    id: 0,
                    title: 'Код интеграций не активирован'
                },
                enabled: {
                    id: 1,
                    title: 'Код интеграций активирован',
                }
            }
        }
    },

    computed: {
        backgroundStyle: function () {
            var style = {
                'backgroundColor': this.s.landing_background_color,
                'backgroundSize': 'cover',
                'backgroundRepeat': 'no-repeat',
                'backgroundPosition': 'center center',
                'color': this.s.landing_text_color,
            };
            // если выбран режим фонового изображения, грузим его
            if (+this.s.landing_background_type === this.landingStatuses.backgroundTypes.image.id) {
                style['backgroundColor'] = 'white';
                style['backgroundImage'] = 'url(' + window.WBK_Settings.staticServerUrl + '/uploaded/temp/' + this.s.landing_img_src + ')';
            }
            return style;
        },

        buttonStyle : function () {
            var style = {
                'backgroundColor': this.s.landing_btn_show_quiz_color,
                'border' : 0,
                'color' : this.s.landing_btn_show_quiz_text_color,
            };

            return style;
        },
    },

    created: function () {
        this.initEvents();
        this.getSettings();
    },

    methods : {
        /**
         * Загрузка данных квиза
         */
        getSettings : function () {
            var _t = this;
            $.getJSON(this.$options.settings.apiUrl+this.widgetId, {
                widgetId: this.widgetId,
                code: window.WBK_Settings.whiteSaasCode,
                action : 'getData',
                isajax: true,
            }, function (result) {
                if(result.status === 'success') {
                    _t.setData(result.data);
                }
            });
        },

        /**
         * Добавляем обрабочтики событий
         */
        initEvents : function () {
            var _t = this;
            $(window).on("message", function(event) {
                var data = event.originalEvent.data;
                // ловим событие от iframe с квизом о ресайзинге
                if (_t.widgetId !== +data.quizId || !wsQuizzes.hasOwnProperty(_t.widgetId)) {
                    return;
                }
                if (data.action === 'visible_iframe') {
                    // показываем квиз
                    _t.visibility = 'visible';
                    wsQuizzes[_t.widgetId].sendResizeBlockAnswerEvent();
                }
            });
        },

        /**
         * Устанавиливаем данные
         * @param data
         */
        setData : function (data) {
            this.s = data.settings;
            this.is_envybox = data.isEnvyBox;
            this.quiz = data;
            this.partnerLink = data.partnerLink;
            if (!this.is_envybox) {
                this.partnerLink = 'http://' + window.WBK_Settings.serviceDomain + '?utm_source=widget&utm_medium=self&utm_campaign=' + location.hostname + '&utm_content=quiz&utm_term=';
            }
            this.serviceName = window.WBK_Settings.serviceName;
            this.loadingOff();
        },

        /**
         * Показываем квиз
         */
        showQuiz : function () {
            this.show = true;
            this.$nextTick(function () {
                if (!wsQuizzes.hasOwnProperty(this.widgetId)) {
                    return;
                }
                // если квиз уже есть на странице, отправляем запрос на перерисовку
                if (document.getElementById("ws-quiz-iframe-" + this.widgetId) && document.getElementById("ws-quiz-iframe-" + this.widgetId).contentWindow) {
                    wsQuizzes[this.widgetId].sendResizeBlockAnswerEvent();
                } else {
                    // если квиза нет, то подгружаем его
                    wsQuizzes[this.widgetId].initWidget();
                }
                wsQuizzes[this.widgetId].sendResizeBlockAnswerEvent();
            }.bind(this));
        },

        /**
         * Отключение экрана загрузки
         */
        loadingOff : function () {
            this.loading = false;
            var _this = this;
            // ожидаем загрузки квиза
            var timerTryToShow = setInterval(function () {
                if (window.wsQuizzes && wsQuizzes.hasOwnProperty(_this.widgetId)) {
                    _this.init();
                    clearInterval(timerTryToShow);
                    wsQuizzes[_this.widgetId].hideWidget();
                }
            }, 400);
        },

        /**
         * Активирование квиза
         */
        init : function () {
            if (+this.s.landing_view_type === this.landingStatuses.viewTypes.inline.id) {
                this.showQuiz();
            } else {
                this.buttonShowed = true;
            }
        },
    }
});